module.exports = __webpack_public_path__ + "img/Flag_of_Macau.af80e991.svg";